import * as React from 'react';
import { DataGridListItem } from '../../types';
import { ColumnsType } from 'antd/es/table';
import { Tooltip } from '@iba-team/portal-react-components/dist';
import { ReactComponent as InfoIcon } from '../../assets/icons/info.svg';
import { translationEN } from '../help/translations';
import { PROFILE_ROUTE } from '../../utils/consts';
import { Link } from 'react-router-dom';
import { sendUsageRequest } from '../../utils/functions';
import apiConfig from '../../api/routes';

const handleProfileClick = (profileId: number) => {
  sendUsageRequest(`${apiConfig.statisticsUsageService.departmentReportGoToProfile}?profileId=${profileId}`);
};

export const COLUMNS: (onRedirect: ()=> void, openLinkInNewTab?: boolean)  =>  ColumnsType<DataGridListItem> | undefined = (onRedirect, openLinkInNewTab = false) => [
  {
    title: '#',
    name: '#',
    dataIndex: 'key',
    key: 'key',
    responsive: ['sm'],
    width: 50,
    align: 'center',
  },
  {
    title: 'Employee',
    name: 'Employee',
    dataIndex: 'latinSurname',
    key: 'latinSurname',

    sorter: (a, b) => a.latinSurname > b.latinSurname ? 1 : 0,
    render:(data,record)=> <div className={'employee-container'}>
      <Link
        onClick={() => {
          handleProfileClick(record.id);
        }}
        onAuxClick={() => {
          handleProfileClick(record.id);
        }}
        to={`${PROFILE_ROUTE}/${record.id.toString()}`} 
        className={'tableTitle doubleRow'}
        {...(openLinkInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}>
        <div className={record.activeEmployee? 'tableUsername': 'tableUsername_inactive'}>
          <span>{data} {record.latinName} {!record.activeEmployee && '[Inactive]'} </span>
        </div>
      </Link>
      <div className={'countryName'}>{record.location}</div>
    </div>,
    ellipsis: true,
    width: 220,
  },
  {
    title: 'Division',
    name: 'Division',
    dataIndex: 'division',
    key: 'division',
    responsive: ['xl'],
    render:(data)=> <Tooltip placement="topLeft">{data}</Tooltip>,
    align: 'left',
    ellipsis: true,
    width: 180,
  },
  {
    title:  <Tooltip title={translationEN.reportDepAllowance}>
      <div className={'tableHeader_container'}>
        <div>Total Allowance</div>
        <InfoIcon className={'tooltipDep'} />
      </div>
    </Tooltip>,
    dataIndex: 'allowanceDays',
    name: 'Allowance',
    key: 'allowanceDays',
    render:(data)=> <div className={'tableTitle bolderNumber'}>{data}</div>,
    width: 160,
  },
  {
    title: <Tooltip title={translationEN.reportDepUsed}>
      <div className={'tableHeader_container'}>
        <div>Used</div>
        <InfoIcon className={'tooltipDep'} />
      </div>
    </Tooltip>,
    dataIndex: 'usedDays',
    name: 'Used',
    key: 'usedDays',
    render:(data)=> <div className={'tableTitle bolderNumber'}>{data}</div>,
    width: 80,
  },
  {
    title: <Tooltip title={translationEN.reportDepAvailable}>
      <div className={'tableHeader_container'}>
        <div>Available for now</div>
        <InfoIcon className={'tooltipDep'} />
      </div>
    </Tooltip>,
    showSorterTooltip: false,
    name: 'Available',
    className: 'availableDaysCustomColumn',
    dataIndex: 'availableDays',
    key: 'availableDays',
    sorter: (a, b) => a.availableDays - b.availableDays,
    render:(data)=> <div className={'tableTitle bolderNumber'}>{data}</div>,
    width: 180,
  },
  {
    title: <Tooltip title={translationEN.reportDepUnusedTransfer}>
      <div className={'tableHeader_container'}>
        <div>Unused Transfer</div>
        <InfoIcon className={'tooltipDep'} />
      </div>
    </Tooltip>,
    showSorterTooltip: false,
    name: 'Transferred',
    className: 'transferedDaysCustomColumn',
    dataIndex: 'transferedDays',
    key: 'transferedDays',
    sorter: (a, b) => a.transferedDays - b.transferedDays,
    render:(data)=> <div className={'tableTitle bolderNumber'}>{data}</div>,
    width: 160,
  },
];


